<template>
    <span
        v-if="type"
        :class="[
            `product-badge absolute flex items-center ${classWrapper}`,
            {
                [BADGE_TYPE_MAPPING[type]?.backgroundColor]: size === 'medium',
            },
        ]"
    >
        <img
            :src="`${staticUrl}/assets/img/v2/${BADGE_TYPE_MAPPING[type]?.icon}.png`"
            :class="`h-auto ${classImage}`"
            :alt="BADGE_TYPE_MAPPING[type]?.icon"
            loading="lazy"
        />
        <span v-if="size === 'medium'" class="font-semibold text-white">
            {{ $t(BADGE_TYPE_MAPPING[type]?.i18Key) }}
        </span>
    </span>
</template>
<script setup>
import { BADGE_TYPE_MAPPING } from '@/constants/menu.js'

defineProps({
    type: {
        type: String,
        default: '',
    },
    size: {
        type: String,
        default: 'small', // small, medium
    },
    classWrapper: {
        type: String,
        default: '',
    },
    classImage: {
        type: String,
        default: '',
    },
})

const staticUrl = useRuntimeConfig().public.staticUrl
</script>
